import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { Cell, Grid, Row } from "../../../../_foundation/_grid";
import MMTabs from "../../../../mmcomponents/mmtabs/MMTabs";
import ElementSettings from "./ElementSettings";
import ElementDesign from "./ElementDesign";
import Loading from "../../../../_reusables/Loading";
import TextEditor from "../../controls/components/TextEditor";
import Box from "../../../../layout/Box";

const tabs = {
  content: {
    name: "Inhalt",
    icon: "pencil-square-o",
  },
  design: {
    name: "Design",
    icon: "paint-brush",
  },
  settings: {
    name: "Einstellungen",
    icon: "cog",
  },
};

function PopupText(props) {
  const [element, setElement] = useState(null);
  const [selectedTab, setSelectedTab] = useState("content");
  const [editorMode, setEditorMode] = useState("visual");

  useEffect(() => {
    setElement(cloneDeep(props.element));
  }, [props.element]);

  useEffect(() => {}, [element]);

  const onEdit = (property, value) => {
    if (props.actions.onEdit) props.actions.onEdit(property, value);
  };

  const onEditHtml = (value, html) => {
    if (props.actions.onEditHtml) props.actions.onEditHtml(value, html);
  };

  const actions = {
    onEdit,
    onEditHtml,
    setEditorMode,
  };

  if (!element)
    return (
      <div className="text-center">
        <Loading show={true} />
      </div>
    );

  return (
    <div className="element-popup-text">
      <div className="admin-tabs">
        <MMTabs
          tabs={tabs}
          selected={selectedTab}
          onUpdate={(selectedKeyName) => setSelectedTab(selectedKeyName)}
        />
      </div>
      {selectedTab === "content" && (
        <TabContent
          element={element}
          actions={actions}
          editorMode={editorMode}
        />
      )}
      {selectedTab === "design" && (
        <ElementDesign item={element} itemType="element" actions={actions} />
      )}
      {selectedTab === "settings" && (
        <ElementSettings item={element} actions={actions} />
      )}
    </div>
  );
}

const TabContent = ({ element, editorMode, actions }) => {
  return (
    <Grid type="full">
      <Row margin="xy">
        <Cell sm={24}>
          <Box size="small">
            <TextEditor
              key={`text_${element.identifier}`}
              value={element.content}
              html={element.content_html}
              allowVisual={true}
              mode={editorMode}
              onChange={({ value, html, mode }) => {
                actions.onEditHtml(value, html);
                actions.setEditorMode(mode);
              }}
            />
          </Box>
        </Cell>
      </Row>
    </Grid>
  );
};

export default PopupText;
